import React, { Fragment } from 'react'
import { useLocation } from 'react-router-dom'
import { ClientSecureHooksContainer } from './ClientSecureHooksContainer'
import { ContractorPortalSecureHooksContainer } from './ContractorPortalSecureHooksContainer'
import { useAuthTokens } from './hooks/useAuthTokens'

export const HooksContainer = () => {
  const location = useLocation()

  const { authToken, contractorPortalAuthToken } = useAuthTokens()

  return (
    <Fragment>
      {!location.pathname.includes('/contractor/') && authToken && <ClientSecureHooksContainer />}
      {location.pathname.includes('/contractor/') && contractorPortalAuthToken && (
        <ContractorPortalSecureHooksContainer />
      )}
    </Fragment>
  )
}
